import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { startOppdateringsvakt } from "./state/oppdatering";
import "./styles/global.css";
import "./styles/surfaces.css";
import "./styles/liquid-glass.css";
import "./styles/overlays.css";

/*
 * Service workeren registreres herfra og ikke av et injisert skript.
 * Se state/oppdatering.ts — en «prompt» uten spoersmaal betyr at en ny
 * versjon venter for alltid.
 */
startOppdateringsvakt();

const root = document.getElementById("root");
if (root === null) throw new Error("Fant ikke #root");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
